import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Imports from "@/pages/Imports";
import Orders from "@/pages/Orders";
import ProductAnalysis from "@/pages/ProductAnalysis";
import CustomerAnalysis from "@/pages/CustomerAnalysis";
import RegionAnalysis from "@/pages/RegionAnalysis";
import Control from "@/pages/Control";
import ProductPrices from "@/pages/ProductPrices";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import CohortRetention from "@/pages/CohortRetention";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Auth callback detection must be synchronous (during render) to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/imports" element={<Imports />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/producten-analyse" element={<ProductAnalysis />} />
        <Route path="/klanten-analyse" element={<CustomerAnalysis />} />
        <Route path="/klantretentie" element={<CohortRetention />} />
        <Route path="/regio-analyse" element={<RegionAnalysis />} />
        <Route path="/controle" element={<Control />} />
        <Route path="/producten" element={<ProductPrices />} />
        <Route path="/instellingen" element={<Settings />} />
        <Route path="/gebruikers" element={<Users />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
